import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as amplitude from '@amplitude/analytics-browser';

import {
  AmplitudeFixedUserProperty,
  AmplitudeVariableUserProperty,
  User,
} from 'src/interfaces/iuser';
import { useIsLoggedIn } from './useCustomHooks';
import { AmplitudeEventType } from 'src/interfaces/idashboard';

export const useIdentifyAmplitudeUser = () => {
  const isLoggedIn = useIsLoggedIn();
  const user: User = useSelector(state => (state as any).dashboard.user);

  useEffect(() => {
    if (isLoggedIn && user && !user.loading && user.email != 'Trial') {
      const userEmail = user.email;
      amplitude.setUserId(userEmail);

      const fixedUserProperty: AmplitudeFixedUserProperty = {
        email: user.email,
        name: user.userName,
        description: user.userDescription,
        signupDate: user.userSignUpDay,
        signupTimestamp: user.signupTimestamp,
        signupCountryCode: user.signupCountryCode,
        signupIpAddress: user.signupIpAddress,
      };

      const variableUserProperty: AmplitudeVariableUserProperty = {
        role: user.role,
        customerId: user.customerID,
        subscriptionPlan: user.subscriptionPlan,
      };

      const identifyEvent = new amplitude.Identify();

      // static properties that will be set just once in amplitude
      Object.entries(fixedUserProperty).forEach(([key, value]) => {
        identifyEvent.setOnce(key, value);
      });

      // these properties can be updated/added
      Object.entries(variableUserProperty).forEach(([key, value]) => {
        identifyEvent.set(key, value);
      });

      amplitude.identify(identifyEvent);
    }
  }, [user, isLoggedIn]);
};
